export default __webpack_public_path__ + "static/media/skull.40e5518f.gif";